/** Inline stat row (icon + value + label). Used in the Gallery header. */
export const Stat = ({ label, value, tone, icon, testId }) => (
  <div className="flex items-baseline gap-1.5" data-testid={testId}>
    {icon && <span className={tone}>{icon}</span>}
    <span className={`text-lg leading-none [font-variant-numeric:lining-nums_tabular-nums] ${tone}`}>{value}</span>
    <span className="text-[10px] uppercase tracking-[0.16em] text-leaf-mist">{label}</span>
  </div>
);

export default Stat;
